
export {
  i18nConfig
}

function i18nConfig (queryParamGetter, $translateProvider, $injector) {
  'ngInject';

  let requiredLanguage = queryParamGetter('iceLang', true);
  let defaultLanguageId = 'it';

  let LANGUAGES = {
    english:"en_EN",
    italian:"it_IT"
  };


  // <Injecting languages content>
  let languageContent = {};
  let languageId = "";

  for (let itemLang in LANGUAGES) {
    try {
      // messages_... contiene le traduzioni dei moduli base (app/i18n/)
      languageId = LANGUAGES[itemLang];
      languageContent = $injector.get('messages_' + languageId.split('_')[0]);
      $translateProvider.translations(languageId, languageContent);
      console.log('injected language content '+languageId);
    }
    catch (e) {
      console.log('ERROR language translations: ', languageId, e.message, e.stack, e);
    }
  }
  // </Injecting languages content>


  let AVAILABLE_LANGUAGES = {
    keys: [
      LANGUAGES.english,
      LANGUAGES.italian
    ],
    map: {
      'en'    : LANGUAGES.english,
      'en_*'  : LANGUAGES.english,
      'en-*'  : LANGUAGES.english,
      'it'    : LANGUAGES.italian,
      'it_*'  : LANGUAGES.italian,
      'it-*'  : LANGUAGES.italian
    }
  };

  $translateProvider
    .registerAvailableLanguageKeys(AVAILABLE_LANGUAGES.keys, AVAILABLE_LANGUAGES.map)
    .useSanitizeValueStrategy('escaped')
    .use(LANGUAGES.italian)
    //.determinePreferredLanguage()
    .fallbackLanguage(LANGUAGES.italian)
  //.useLocalStorage();

}




// WEBPACK FOOTER //
// ./client/app/app.config/i18n.config.js